export default {
    'odkryj_dostep':'Scopri tutte le categorie e goditi l\'accesso completo.',
			'odkryj_dostep_opis':  'Solo un giocatore paga e sblocca il gioco per entrambi!',
            'kontynuuj_gre':  'Continua a giocare',
            'zacznij_od_nowa':  'Ricomincia',
            'dolacz_do_gry':  'Unisciti al gioco',
            'prosze_czekac':  'Attendere prego',
            'zamknij':  '<i class="fa fa-times"></i> Chiudi',
            'start_gry':  "Inizio del gioco",
			'graj':  'Giocare',
			'wpisz_imiona_graczy':'Inserisci i nomi dei giocatori',
			'twoje_imie':'Il tuo nome',
			'imie_drugiego_gracza':'nome del secondo giocatore',
			'wyslij_zaproszenie':  'Invia invito <i class="fas fa-chevron-right"></i>',
			'konfiguracja_polaczenia':  'Configurazione connessione',
			'daj_drugiemu':  "Consenti all'altro giocatore di scansionare il codice qui sotto",
			'wpisz_imiona':  'Inserisci i nomi di entrambi i giocatori',
			'wpisz_rozne_imiona':  'Inserisci nomi diversi tra loro',
			'odblokowane':  'Tutti i livelli sono stati sbloccati. Continua a giocare!',
			'poziomy':  'Categorie',
			'rozpocznij_gre':  'Avvia gioco <i class="fas fa-chevron-right"></i>',
			'poziom1':  'Livello 1',
			'poziom2':  'Livello 2',
			'poziom3':  'Livello 3',
			'oczekuje_na_druga_osobe':  'In attesa della risposta dell\'altra persona',
			'oczekuje_na_druga_osobe_2':  'Aspettando l\'altra persona',
			'graj_dalej':  'Continua a giocare <i class="fas fa-chevron-right"></i>',
			'dokoncz_gre':  'Termina il gioco <i class="fas fa-chevron-right"></i>',
			'odpowiadaj_na_pytania':  'Rispondere alle domande',
			'pytanie':  'Domanda',
			'z':'Con',
			'oczekuje_na_osobe':  'In attesa della risposta dell\'altra persona',
			'wyniki_rozgrywki':  "Risultati del gioco",
			'gratulacje':  "Congratulazioni",
			'macie_zgodnosc':  "Sei compatibile",
			'znasz_grugiego_gracza':  "Conosci l'altro giocatore",
			'zna_ciebie':  "ti conosce",
			'jak_odpowiadaliscie':  '<i class="fas fa-tasks"></i> Guarda come hai risposto',
			'pochwal_sie':  '<i class="fas fa-share-alt"></i> Mostra il tuo punteggio',
			'wasze_odpowiedzi':  "le tue risposte",
			'skanuj_kod':"Scansione codice",
			'statystyka':  "Statistiche",
			'statystyka_gry':  "Statistiche di gioco",
			'powiadom':  '<i class="fas fa-envelope" style="right:auto; left: 15px"></i> Notifica sulla nuova versione',
			'zapisalismy_cie':  'Abbiamo salvato il tuo indirizzo e-mail',
			'rozpocznij':  'Avvia <i class="fas fa-chevron-right"></i>',
			'poznajcie_sie':  "Conoscersi",
			'jak_znasz':  "Matching Halves è un gioco per coppie che metterà alla prova quanto bene conosci il tuo partner e quanto bene lui conosce te.",
			'help1':  "Hai già iniziato il gioco. Se vuoi continuare, premi il pulsante in basso.",
			'help2':  "Tuttavia, vuoi ricominciare il gioco o con un nuovo giocatore: premi il pulsante in basso.",
			'help3':  "Sii il primo giocatore a configurare il gioco: aggiungi i nomi dei giocatori e chiedi al secondo giocatore di scansionare il codice generato.",
			'help4':  "Dopo che il primo giocatore ha generato il codice, premi il pulsante in basso e scansiona il codice.",
			'help5':  "Dopo aver inserito i nomi dei giocatori, premi il pulsante \"Invia invito\" e fai scansionare il codice generato dall'altro giocatore.",
			'help6':  "Consenti all'altro giocatore di scansionare il codice qui sotto",
			'help7':  "Scansiona il codice generato dall'altro giocatore",
			'kup':  "Acquistare",
			'zagraj_ponownie':  '<i class="fas fa-play" style="right:auto; left: 15px"></i> Riproduci di nuovo',
			'opis_gry':  'Descrizione del gioco',
			'poziom':  'Livello',
			'ext_desc':  '<br>Matching Halves è un gioco per coppie che ti permetterà di testare quanto bene conosci il tuo partner e quanto lui conosce te.<br><br>Giochi online contemporaneamente su due dispositivi. Entrambi dovete scaricare il gioco dallo store.<br><br>Una persona avvia il gioco facendo clic sul pulsante "Avvia gioco" e inserisce i vostri nomi.<br><br>L\'altra persona si unisce al gioco facendo clic sul pulsante Pulsante "Partecipa al gioco" e scansiona il codice generato dalla persona che inizia il gioco. Dopo aver scansionato il codice, a entrambi i giocatori verrà mostrato l\'inizio del gioco e le categorie.<br><br>L\'applicazione ha 6 categorie, ciascuna con 3 livelli di difficoltà. Inizi con il livello più semplice, ovvero il livello 1 (il completamento del livello 1 ti consente di iniziare il livello successivo).<br><br>Non lasciarti scoraggiare da domande apparentemente semplici, perché più ti addentri nella foresta sarà più difficile e più piccante!<br><br>W allo stesso tempo, la stessa domanda apparirà sui tuoi telefoni o tablet, a cui rispondi sì / no o contrassegna una risposta specifica. Il tuo compito è solo quello di fare clic sulla risposta corretta.<br><br>Prima rispondi a ciò che pensa il tuo partner, poi rispondi tu stesso a ciò che pensi. Dopo ogni livello, puoi controllare come hai risposto e quale percentuale hai ottenuto.<br><br>Puoi interrompere il gioco in qualsiasi momento e terminarlo più tardi, ma se riavvii il gioco, le tue risposte precedenti vengono cancellate.<br> <br>Buon divertimento! <br><br><br><br><br><br>',
			'druga_osoba_odpowiedziala':  'L\'altra persona sta aspettando la tua risposta',
			'confirm_text_1':  'Vuoi ricominciare il gioco?',
			'confirm_text_2':  'Perderai le risposte precedenti.',
			'yes_button':  '<i class="fa fa-check"></i> Sì, sto ricominciando da capo',
			'no_button':  '<i class="fa fa-times"></i> No, sto ancora giocando',
			'back':  '<i class="fas fa-chevron-left"></i> indietro',
			'backk':  '<i class="fas fa-chevron-left" style="right:auto;left:15px;"></i> Indietro',
			'podsumowanie_wynikow':  'Riepilogo risultati<i class="fas fa-chevron-right"></i>',
			
						
			
'Życie codzienne': 'Vita di ogni giorno',
			'Daily life': 'Vita di ogni giorno',
			'La vida cotidiana': 'Vita di ogni giorno',
			'Vie courante': 'Vita di ogni giorno',
			'Alltagsleben': 'Vita di ogni giorno',
			'Vita di ogni giorno': 'Vita di ogni giorno',
			'Vida cotidiana': 'Vita di ogni giorno',
			
			'Osobowość / charakter': 'Personalità/carattere',
			'Personalità/carattere': 'Personalità/carattere',
			'Personality / character': 'Personalità/carattere',
			'Caracter personal': 'Personalità/carattere',
			'Caractère de la personnalité': 'Personalità/carattere',
			'Personalidade / personagem': 'Personalità/carattere',
			'Persönlichkeit Charakter': 'Personalità/carattere',
			
			'Życie towarzyskie': 'Vita sociale',
			'Social life': 'Vita sociale',
			'Vida social': 'Vita sociale',
			'Vie sociale': 'Vita sociale',
			'Soziales Leben': 'Vita sociale',
			'Vita sociale': 'Vita sociale',
			
			'Wyznawane wartości': 'Valori sposati',
			'Values / beliefs': 'Valori sposati',
			'Valores propugnados': 'Valori sposati',
			'Valeurs adoptées': 'Valori sposati',
			'Valores expostos': 'Valori sposati',
			'Vertraute Werte': 'Valori sposati',
			'Valori sposati': 'Valori sposati',
			
			'Nałogi / nawyki': 'Dipendenze/abitudini',
			'Habits / Addictions': 'Dipendenze/abitudini',
			'Adicciones / hábitos': 'Dipendenze/abitudini',
			'Dépendances / habitudes': 'Dipendenze/abitudini',
			'Vícios / hábitos': 'Dipendenze/abitudini',
			'Süchte / Gewohnheiten': 'Dipendenze/abitudini',
			'Dipendenze/abitudini': 'Dipendenze/abitudini',
			
			'Seks':'Sesso',
			'Sex':'Sesso',
			'Sexo':'Sesso',
			'Sexe':'Sesso',
			'Sesso':'Sesso',
			
			
            'polski': 'Polski',
            'angielski': 'English',
            'hiszpanski': 'Español',
            'wloski': 'Italiano',
            'francuski': 'Français',
			'portugalski': 'Português',
			'niemiecki': 'Deutsch',
			'jasny': 'Chiaro',
			'ciemny': 'Scuro',
			'blad_polaczenia': "Errore di connessione. Riprova.",
			'przekaz_kod_gry': "Il tuo codice di gioco",
			'przekaz_kod_gry_drugi_gracz': "Puoi anche fornire il codice di gioco per il secondo giocatore",
"skanuj_kod_aparatem": "Scansiona il codice con la fotocamera",
  "wpisz_kod_recznie": "Inserisci il codice manualmente",
  "wprowadz_kod": "Inserisci il codice ricevuto",
  "wprowadz_kod_gry": "Inserisci il codice del gioco",
  "help8": "Nel campo sottostante inserisci il codice di gioco ricevuto dal secondo giocatore. Una volta inserito, la partita si avvierà automaticamente",
    "nieprawidlowy_kod_gry": "Il codice inserito non è valido",
  "powrot_do_kategorii": "Torna alle categorie"


}